export default __webpack_public_path__ + "static/frontpage-bg_new-8ff12015f630a5598688a4879e775497.jpg";